import React from 'react'
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div id='NotFound' style={{ textAlign: 'center', padding: '8rem 2rem' }}>
      <Helmet>
        <title>Page introuvable | Instants de Soie</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <h1 style={{ fontSize: '4rem', marginBottom: '1rem' }}>404</h1>
      <h2>Page introuvable</h2>
      <p style={{ margin: '2rem 0', opacity: 0.6 }}>La page que vous recherchez n'existe pas ou a été déplacée.</p>
      <Link className='button black' to="/" style={{ display: 'inline-block', textDecoration: 'none', color: 'whitesmoke', backgroundColor: 'black', border: '1px solid black', borderRadius: '4px', padding: '1rem 3rem', fontWeight: 600 }}>
        Retour à l'accueil
      </Link>
    </div>
  )
}

export default NotFound
